export const Colors = {
    colors: {
      colorPrimary0: "#FFFFFF",
      colorPrimary50: "#E6E6E6",
      colorPrimary100: "#CCCCCC",
      colorPrimary200: "#B3B3B3",
      colorPrimary300: "#999999",
      colorPrimary400: "#808080",
      colorPrimary500: "#CCCCCC",
      colorPrimary600: "#4D4D4D",
      colorPrimary700: "#333333",
      colorPrimary800: "#1A1A1A",
      colorPrimary1000: "#FFFFFF",

      colorIcons: "#FFFFFF",
      colorText: "#FFFFFF",
      colorMutedText: "#FFFFFFB3",
      colorBtnText: "#FFFFFF",
      colorHover: "#FFFFFF",
      colorOn: "#E6E6E6",

      colorStatusError: "#FFFFFF",
      colorStatusTrue: "#FFFFFF",
      colorStatusInfo: "#FFFFFF",
      colorStatusWarning: "#FFFFFF",
      colorBarError: "#ffffff",
      colorBarWarning: "#ffffff",
      colorBarProgress: "#000000",


      colorTextReverse: "#000000",
      colorContrast: "#FFFFFF",
      colorOff: "#6e6e6e",
      colorPositive: "#FFFFFF",
      colorNegative: "#FFFFFF",
      colorDndText: "#FFFFFF",
      colorMenu: "#b2b2b2",

      colorProgress20: "#FFFFFF",
      colorProgress40: "#FFFFFF",
      colorProgress60: "#FFFFFF",
      colorProgress80: "#FFFFFF",
      colorProgress100: "#FFFFFF",
      colorProgress120: "#FFFFFF",
  
      colorBlue100: "#FFFFFF",
      colorBlue200: "#CCCCCC",
      colorBlue300: "#999999",
      colorBlue1000: "#FFFFFF",

      colorPurple: "#800080", 
      colorPink: "#FFC0CB",
      colorWhite: "#FFFFFF",

    },
  };
